import React from 'react';
import { ContentContainer, Card, Gutter, Text, Gap } from '@common/components';
import { Col, Row } from 'antd';
import { NewSupplierFormValues } from './_suppliers-management-new-supplier-step-details';
import {
  SupplierDetailsSummary,
  type TieringRadioTierType,
} from '@institutions/components';
import type { OrganizationUnitType } from '@institutions/graphql';

export function SuppliersManagementNewSupplierStepSummary({
  selectedTier,
  selectedRoles,
  supplierDetails,
  canUserSeeTiering,
  selectedOrganizationUnits,
}: {
  selectedTier: TieringRadioTierType;
  selectedRoles: string[];
  supplierDetails?: NewSupplierFormValues;
  canUserSeeTiering: boolean;
  selectedOrganizationUnits: OrganizationUnitType[];
}) {
  return (
    <ContentContainer title={supplierDetails?.supplierName}>
      <Gutter size="lg" direction="bottom">
        <Row>
          <Col span={12}>
            <Card>
              <Gap size="md" vertical>
                <Gap size="xs" vertical>
                  <Text color="midnightDarker" block>
                    Send To
                  </Text>
                  <Text weight="medium" size="lg" block>
                    {supplierDetails?.mainContactEmail || '—'}
                  </Text>
                </Gap>
                {supplierDetails?.invitationMessage && (
                  <Gap size="xs" vertical>
                    <Text color="midnightDarker" block>
                      Invitation Message
                    </Text>
                    <Text weight="medium" size="lg" block>
                      {supplierDetails.invitationMessage}
                    </Text>
                  </Gap>
                )}
              </Gap>
            </Card>
          </Col>
        </Row>
      </Gutter>

      <SupplierDetailsSummary
        selectedTier={selectedTier}
        selectedRoles={selectedRoles}
        canUserSeeTiering={canUserSeeTiering}
        selectedOrganizationUnits={selectedOrganizationUnits}
      />
    </ContentContainer>
  );
}
